import React from 'react';
import ReactDOM from 'react-dom';
import 'simplebar/dist/simplebar.min.css';
import './index.scss';
// import reportWebVitals from './reportWebVitals';
import store from './core/store';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { HelmetProvider } from 'react-helmet-async';
import './translations/i18n';
import { VisitorProvider } from './context/visitorContext';
import 'intersection-observer';
import App from './App';
import { HubspotBookMeetingModalWrapper } from './context/bookMeetingModalContext';
import { BrowserTracing } from '@sentry/tracing';
import 'promise-polyfill/src/polyfill';

import * as Sentry from '@sentry/react';
import { INITIAL_LD_KEY } from './core/constants';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://9bc9817c20a740ddb62106f4572808da@o506743.ingest.sentry.io/6691812',
    integrations: [new BrowserTracing()],
    environment: process.env.REACT_APP_ENV,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID || '',
    user: {
      key: INITIAL_LD_KEY,
    },
  });

  ReactDOM.render(
    <React.StrictMode>
      <LDProvider>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <HelmetProvider>
              <VisitorProvider>
                <HubspotBookMeetingModalWrapper>
                  <App />
                </HubspotBookMeetingModalWrapper>
              </VisitorProvider>
            </HelmetProvider>
          </Provider>
        </QueryClientProvider>
      </LDProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
